export const SET_EDUCATION_RECOMMEND_BANNER = 'SET_EDUCATION_RECOMMEND_BANNER';
export const GET_EDUCATION_RECOMMEND_BANNER = `GET_EDUCATION_RECOMMEND_BANNER`;

export const SET_EDUCATION_RECOMMEND_GROUPS = 'SET_EDUCATION_RECOMMEND_GROUPS';
export const GET_EDUCATION_RECOMMEND_GROUPS = `GET_EDUCATION_RECOMMEND_GROUPS`;
export const SET_EDUCATION_RECOMMEND_LOADING = 'SET_EDUCATION_RECOMMEND_LOADING';
export const SET_EDUCATION_RECOMMEND_TAG_ERROR = `SET_EDUCATION_RECOMMEND_TAG_ERROR`;

export const GET_EDUCATION_CATEGORY_TAGS = `GET_EDUCATION_CATEGORY_TAGS`;
export const SET_EDUCATION_CATEGORY_TAGS = `SET_EDUCATION_CATEGORY_TAGS`;

export const GET_EDUCATION_CATEGORY_GRADELIST = `GET_EDUCATION_CATEGORY_GRADELIST`;
export const SET_EDUCATION_CATEGORY_GRADELIST = `SET_EDUCATION_CATEGORY_GRADELIST`;
export const SET_EDUCATION_CATEGORY_ERROR = `SET_EDUCATION_CATEGORY_ERROR`;
export const SET_EDUCATION_CATEGORY_LOADING = `SET_EDUCATION_CATEGORY_LOADING`;

export const GET_EDUCATION_MINE_GRADELIST = `GET_EDUCATION_MINE_GRADELIST`;
export const SET_EDUCATION_MINE_GRADELIST = `SET_EDUCATION_MINE_GRADELIST`;
export const DELETE_EDUCATION_MINE_GRADELIST = `DELETE_EDUCATION_MINE_GRADELIST`;
export const OPERATION_EDUCATION_MINE_GRADELIST = `OPERATION_EDUCATION_MINE_GRADELIST`;
export const SET_EDUCATION_MINE_ERROR = `SET_EDUCATION_MINE_ERROR`;
export const SET_EDUCATION_MINE_LOADING = `SET_EDUCATION_MINE_LOADING`;

export const GET_EDUCATION_DETAIL = `GET_EDUCATION_DETAIL`;
export const SET_EDUCATION_DETAIL = `SET_EDUCATION_DETAIL`;
export const GET_EDUCATION_PLAY_URL = `GET_EDUCATION_PLAY_URL`;
export const SET_EDUCATION_PLAY_URL = `SET_EDUCATION_PLAY_URL`;
export const GET_EDUCATION_PLAY_DATA_REPORT = `GET_EDUCATION_PLAY_DATA_REPORT`;
export const SET_EDUCATION_PLAY_DATA_REPORT = `SET_EDUCATION_PLAY_DATA_REPORT`;
export const GET_EDUCATION_COLLECT_REPORT = `GET_EDUCATION_COLLECT_REPORT`;
export const SET_EDUCATION_COLLECT_REPORT = `SET_EDUCATION_COLLECT_REPORT`;

export const GET_EDUCATION_PAY_CREATE = `GET_EDUCATION_PAY_CREATE`;
export const SET_EDUCATION_PAY_CREATE = `SET_EDUCATION_PAY_CREATE`;
export const GET_EDUCATION_PAY_RESULT = `GET_EDUCATION_PAY_RESULT`;
export const SET_EDUCATION_PAY_RESULT = `SET_EDUCATION_PAY_RESULT`;

export const GET_EDUCATION_NEW_TABS = `GET_EDUCATION_NEW_TABS`;
export const SET_EDUCATION_NEW_TAGS = `SET_EDUCATION_NEW_TAGS`;
